import React, { useState, useEffect, useContext } from 'react';
import { Grid } from '@mui/material';
import getConfig from 'next/config';
import { useRouter } from 'next/router';
import { useApolloClient } from '@apollo/client';
import CrossSellInitiateContainer from './CrossSellInitiateContainer';
import CrossSellPreContainer from './CrossSellPreContainer';
import { CSonLoad } from './CrossSell.util';
import RootContext from '../../../util/root.context';
import { displayCart } from '../eir-cart/cart.util';
import ErrorModal from '../eir-error-modal/ErrorModal';
import { createCrossSellProspect } from '../../integration/cross-sell.api';
import { removeCookie, getCookie } from '../../hooks/useCookie';
import useLocalStorage, { clearLocalStorage, setCode } from '../../hooks/useLocalStorage';
// import ErrorModal from '../eir-error-modal/ErrorModal';
import { useToggle } from '../../hooks/useToggle';
import EirChannelModal from '../eir-channel-modal/EirChannelModal';
import LoginMain403 from '../eir-403-login/LoginMain403';
import SessionExpireModal from '../eir-session-expire-modal/sessionExpireModal';

const { publicRuntimeConfig } = getConfig();

const CrossSellContainer = ({
  cmsData = {},
  isVisible = false,
  setOfferCardButtonDisable,
  skipInitiate = false,
  hideTV = false,
  hideMobile = false,
  setClearJourney,
  setShowNext,
  COEligibilityStatus,
  subscriptionId,
  CSFailed,
  myEirTvAdd,
  setMyEirTvAdd,
  subscriptions,
  clearJourneyDetailsOnSubscriptionChange,
  tvChannels = [],
  hideCS,
}) => {
  const [crossSellCardState, setCrossSellCardState] = useState(false);
  const [tvInCart, setTvInCart] = useState(false);
  const [onCSError, setOnCSError] = useState(false);
  const errorModal = useToggle(false);
  const [errorModalOccurence, setErrorModalOccurence] = useState(0);
  const errorModalMaxOccurence = 4;
  const graphql = useApolloClient();
  const { dispatch } = useContext(RootContext);
  const localStore = useLocalStorage();
  const eirChannelModal = useToggle(false);
  const router = useRouter();
  const showModal = useToggle(false);
  const showSessionExpiredModal = useToggle(false);
  const nextStep = () => {
    router.push(`${publicRuntimeConfig.NEXT_PUBLIC_PATH}/redirectSummary`);
  };

  useEffect(() => {
    const localRepoItems = getCookie('found-403');
    if (localRepoItems === 'true') {
      showModal.enable();
    } else {
      showModal.disable();
    }
    const expiredRepoItems = getCookie('token-missing');
    if (expiredRepoItems === 'true') {
      showSessionExpiredModal.enable();
    } else {
      showSessionExpiredModal.disable();
    }
  });

  useEffect(() => {
    const fun = async () => {
      const { cartData, selectedOffer } = await CSonLoad({ graphql, dispatch });
      const isSelected = selectedOffer
        ?.find(item => item.baseOffer.serviceGroup === 'TV')
        ?.baseOffer.catalogTariffPlanCode.includes('CS');
      if (selectedOffer?.length > 0 && isSelected) {
        setTvInCart(true);
        setShowNext(true);
        dispatch({ type: 'ENABLE_FOOTER', payload: false });
        displayCart({
          dispatch,
          localStorage: localStore,
          graphql,
          cart: cartData,
          nextMethod: nextStep,
          disablenNextButton: false,
          showNextButton: false,
        });
      } else {
        setTvInCart(false);
        setShowNext(false);
        dispatch({ type: 'ENABLE_FOOTER', payload: false });
      }
    };
    if (isVisible && subscriptionId === JSON.parse(getCookie('selected_subscription') || '{}').id)
      fun();
    else {
      setTvInCart(false);
      setShowNext(false);
    }
  }, [subscriptionId]);

  function openDialog() {
    eirChannelModal.enable();
  }
  const createCSForECC = async () => {
    if (CSFailed) {
      setOnCSError(true);
      setErrorModalOccurence(errorModalOccurence + 1);
      if (!getCookie('found-403')) errorModal.enable();
      if (!getCookie('token-missing')) errorModal.enable();
      return;
    }
    setCode('CO');
    clearLocalStorage();
    removeCookie('cart_Type');
    removeCookie('reference');
    // setClearJourney(true);
    setCrossSellCardState(true);
    setOfferCardButtonDisable(true);
    // const accountId = JSON.parse(getCookie('selected_subscription'))?.accountId;

    const accountId = getCookie('account_Id');
    await createCrossSellProspect({ graphql, accountId, offerType: 'POSTPAY' });
  };
  useEffect(() => {
    if (COEligibilityStatus === 'ECC') setCrossSellCardState(true);
    else setCrossSellCardState(false);
  }, [COEligibilityStatus, subscriptionId]);

  return (
    isVisible &&
    subscriptionId && (
      <Grid container justifyContent='center'>
        <Grid item xs={12}>
          {crossSellCardState || skipInitiate || tvInCart ? (
            <CrossSellPreContainer
              data={cmsData?.CSPreCards}
              modalCmsData={cmsData}
              tvSelected={tvInCart}
              key={hideTV}
              hideTV={hideTV}
              hideMobile={hideMobile}
              setShowNext={setShowNext}
              COEligibilityStatus={COEligibilityStatus}
              createCSForECC={createCSForECC}
              myEirTvAdd={myEirTvAdd}
              setMyEirTvAdd={setMyEirTvAdd}
              subscriptions={subscriptions}
              clearJourneyDetailsOnSubscriptionChange={clearJourneyDetailsOnSubscriptionChange}
              openDialog={() => {
                openDialog();
              }}
              tvChannels={tvChannels}
              hideCS={hideCS}
            />
          ) : (
            <CrossSellInitiateContainer
              setCrossSellCardState={setCrossSellCardState}
              data={cmsData?.CSInit}
              setOfferCardButtonDisable={setOfferCardButtonDisable}
              setClearJourney={setClearJourney}
              COEligibilityStatus={COEligibilityStatus}
              CSFailed={CSFailed}
            />
          )}
          {/* to enable, do eirChannels.enable() for presale cards */}
          <EirChannelModal
            heading='eir TV'
            id='channel-modal'
            open={eirChannelModal.value}
            handleClose={eirChannelModal.disable}
            disableCloseOnBackdropClick={false}
            disableCloseOnEscapeKeyDown={false}
            tvChannels={tvChannels}
          />
        </Grid>
        <Grid item xs={12}>
          {showModal.value && <LoginMain403 />}
          {showSessionExpiredModal !== undefined && showSessionExpiredModal.value && (
            <SessionExpireModal confirmLogOut={showSessionExpiredModal} />
          )}
          {errorModal && !showModal.value && !showSessionExpiredModal.value && (
            <ErrorModal
              errorBBModal={errorModal}
              occurences={errorModalMaxOccurence}
              currentOccurence={errorModalOccurence}
              ctaMethod={onCSError ? createCSForECC : () => {}}
            />
          )}
        </Grid>
      </Grid>
    )
  );
};

export default CrossSellContainer;
